import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of, forkJoin } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from '../../environments/environment';

export interface GraphStatus {
  url: string;
  name: string;
  description: string;
  version: string;
  changes: string[];
  currentBlock: number;
  isHealthy: boolean;
  error?: string;
}

@Injectable({
  providedIn: 'root'
})
export class GraphStatusService {

  constructor(private http: HttpClient) {}

  getAllGraphStatuses(): Observable<GraphStatus[]> {
    if (!environment.graphStatus || environment.graphStatus.length === 0) {
      return of([]);
    }

    const statusObservables = environment.graphStatus.map(graph => 
      this.getGraphStatus(graph.url, graph.name, graph.description, graph.version, graph.changes)
    );

    return forkJoin(statusObservables);
  }

  private getGraphStatus(url: string, name: string, description: string, version: string, changes: string[]): Observable<GraphStatus> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept': 'application/json, text/plain, */*'
    });

    const body = {
      operationName: 'GetLastBlock',
      variables: {},
      query: 'query GetLastBlock {\n  _meta {\n    block {\n      number\n    }\n  }\n}'
    };
    
    return this.http.post<any>(url, body, { headers }).pipe(
      map(response => {
        if (response && response.data && response.data._meta && response.data._meta.block) {
          return {
            url,
            name,
            description,
            version,
            changes,
            currentBlock: response.data._meta.block.number,
            isHealthy: true
          };
        } else {
          throw new Error('Invalid response');
        }
      }),
      catchError(error => {
        return of({
          url,
          name,
          description,
          version,
          changes,
          currentBlock: 0,
          isHealthy: false,
          error: error.message || 'Failed to fetch status'
        });
      })
    );
  }
}
